import React from "react";
import { FlexContainer } from "src/components";
import { 
    ImageContainer,
    ImagePreview,
    InputDescription,
    TextLabel,
    ErrorMessage,
    BrowseFileButton
} from "../../style";

export const BackgroundImage = (props) => {

    return (
        <FlexContainer>
            <TextLabel fontWeight="bold"> {props.value.quoteUuid ? "Edit" : "Upload"} Background Image  </TextLabel>
            <TextLabel color="#612684" fontSize="15px">
                Upload a high-quality image (JPG, PNG) that will be used as the background for your quote.
            </TextLabel>
            <ImageContainer
                ref={props.value.quoteImageRef}
                onDrop={(file) => props.value.handleAddQuoteImage(file, "quoteImage")}
            >
                { (props.value.quoteImage ? 
                    (props.value.quoteImage) && (
                        <ImagePreview src={props.value.quoteImage} />
                    )
                    :
                    (props.value.renderQuoteImage) && (
                        <ImagePreview src={props.value.renderQuoteImage} />
                    )
                )}
                <BrowseFileButton
                    backgroundColor="#000"
                    color="#fff"
                    border="1px solid #000"
                    size="0.813rem"
                    style={{
                        borderRadius: "7px",
                        boxShadow: "none",
                        position: props.value.quoteImage || props.value.renderQuoteImage ? "absolute" : "relative",
                        right: props.value.quoteImage || props.value.renderQuoteImage ? "-180px" : undefined,
                        zIndex: 200,
                    }}
                    disabled={false}
                >
                    { props.value.quoteImage || props.value.renderQuoteImage ? "Change Image" : "Browse File" }
                </BrowseFileButton>
            </ImageContainer>
            <ErrorMessage>{props.error}</ErrorMessage>
            { (!props.value.quoteImage || props.value.renderQuoteImage) && (
                <InputDescription color="#808080" size="0.938rem" margin="15px 0 0" align="left">
                    Supported formats: JPG, PNG. Max size: 5MB. <br />
                    Aspect Ratio 16:9 - 1920px x 1080px
                </InputDescription>
            )}
        </FlexContainer>
    );
};
